import { render, staticRenderFns } from "./ItemsView.vue?vue&type=template&id=272eadfa&scoped=true&"
import script from "./ItemsView.vue?vue&type=script&lang=ts&"
export * from "./ItemsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272eadfa",
  null
  
)

export default component.exports